import { render, staticRenderFns } from "./MessagesWidget.vue?vue&type=template&id=77ca0fd2"
import script from "./MessagesWidget.vue?vue&type=script&lang=js"
export * from "./MessagesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports